angular.module('dashboard').controller('FormsDashboardCtrl',
    ['$scope', '$q', 'TransitionManager', 'FormsRepository', 'DashboardService', 'PatientPortalStorageRepository',
        function ($scope, $q, TransitionManager, FormsRepository, DashboardService, PatientPortalStorageRepository) {

            'use strict';

            $scope.loading = true;

            $scope.incompleteFormsList = null;
            $scope.practiceFormsList = null;

            var activePatientId = PatientPortalStorageRepository.getActivePatient().id;

            function getAssignedQuestionnaires() {
                return FormsRepository
                    .getAssignedQuestionnaires(activePatientId)
                    .then(function (data) {
                        var assignedForms = data;

                        $scope.incompleteFormsList = _(assignedForms)
                            .filter({'IsComplete' : false})
                            .sortBy('PercentComplete')
                            .value();
                    });
            }

            function getAssignedPracticeForms() {
                var searchCriteria = {
                    IncludeOnlyUnviewedForms : true
                };

                return FormsRepository
                    .getAssignedPracticeForms(activePatientId, searchCriteria)
                    .then(function (data) {
                        $scope.practiceFormsList = data;
                    });
            }

            $scope.load = function(tile) {
                $scope.tile = tile;

                loadPage();
            };

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();
                activePatientId = PatientPortalStorageRepository.getActivePatient().id;

                var assignedQuestionnairesPromise = getAssignedQuestionnaires();
                var assignedPracticeFormsPromise = getAssignedPracticeForms();

                $q.all([assignedQuestionnairesPromise, assignedPracticeFormsPromise]).then(function() {
                    $scope.loading = false;
                })
                .catch(function (response) {
                    $scope.addHttpError(response);
                });
            }

            function displayForms() {
                TransitionManager.transition({appRoute: 'forms'});
            }

            function updateCollapseState()
            {
                $scope.tile.IsCollapsed = !$scope.tile.IsCollapsed;
                DashboardService.setPatientDashboardTileState($scope.tile);
            }

            function openPatientQuestionnaire(form) {
                TransitionManager.transition({appRoute: 'patientQuestionnaire', opts: {relSurveyPatientId: form.RelSurveyPatientId, patientId: form.PatientId, questionnaireId: form.QuestionnaireId}});
            }


            $scope.updateCollapseState = updateCollapseState;
            $scope.displayForms = displayForms;
            $scope.openPatientQuestionnaire = openPatientQuestionnaire;
        }
    ]
);